import React from "react"
import { ProviderFinderParam, useBooleanSearchParam } from "../../utils/providerFinderSearchUrl"
import { FormattedMessage, useIntl } from "react-intl"
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Link,
  Typography
} from "@carrotfertility/carotene-core"
import { Link as RouterLink } from "react-router-dom"
import { useGetFundsAdministration } from "#/components/bank-details/hooks/useGetFundsAdministration"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { useJourney } from "#/components/carrot-plans/hooks/useJourney"
import { DbgPaths } from "#/utils/Paths"

export function DirectPayFilter(): JSX.Element {
  const [acceptsDirectPaySearchParam, setAcceptsDirectPaySearchParam] = useBooleanSearchParam(
    ProviderFinderParam.AcceptsDirectPay
  )
  const intl = useIntl()
  const { mutate: addMemberAction } = useMemberActionTracking()
  const { resolvedJourney } = useJourney()

  const fundsAdministration = useGetFundsAdministration()

  if (!fundsAdministration.data?.reimbursement?.isCarrotDirectPayEnabled) {
    return null
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.tokens.borderRadius.sm
      })}
    >
      <Box display="flex" flexDirection="column" gap={(theme) => theme.spacing(theme.tokens.spacing.md)}>
        <FormControl>
          <FormControlLabel
            label={
              <Box
                component="span"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: (theme) => theme.spacing(theme.tokens.spacing.xxs),
                  minBlockSize: (theme) => theme.spacing(theme.tokens.spacing.lg)
                }}
              >
                <Typography fontWeight="bold" textTransform="uppercase" fontSize="0.75rem">
                  <FormattedMessage defaultMessage="Bills Carrot directly" />
                </Typography>
              </Box>
            }
            aria-label={intl.formatMessage({ defaultMessage: "Select Carrot Center of Excellence type" })}
            control={
              <Checkbox
                name="acceptsDirectPay"
                checked={acceptsDirectPaySearchParam}
                onChange={(event) => {
                  const isChecked = event.target.checked
                  setAcceptsDirectPaySearchParam(isChecked)
                  addMemberAction({
                    memberActionTaken: MemberActions.PROVIDER_FINDER_DIRECT_PAY_FILTER_TOGGLED,
                    metaData: {
                      filterEnabled: isChecked,
                      memberJourney: resolvedJourney
                    }
                  })
                }}
              />
            }
          />
          <FormHelperText sx={{ paddingInlineStart: (theme) => theme.spacing(theme.tokens.spacing.xxl) }}>
            <FormattedMessage
              defaultMessage="Providers that participate in Direct Pay can bill Carrot directly for services covered by your available Carrot funds. <link>Learn more in your benefit guide.</link>"
              values={{
                link: (linkContent) => (
                  <Link to={DbgPaths.DIRECT_PAY} component={RouterLink} color="inherit" fontSize="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}
